"use server";

import { redirect } from "next/navigation";
import type { ActionState } from "@/components/forms/action-state.type";
import { isModuleOn } from "@/modules/app-store";
import { confirmSubscription } from "@/modules/newsletter";
import { getSettingNumber } from "@/modules/settings";

/** The sign-up confirmed from the confirm page (bound to the link's token and language). Nothing is confirmed before this runs, so a mail scanner opening the link subscribes nobody. On success it goes to the same page showing the thanks and the preferences link; a wrong or old link comes back as an error. */
export async function confirmSubscriptionAction(token: string, locale: string): Promise<ActionState> {
  if (!(await isModuleOn("newsletter"))) return { error: "link-invalid" };
  const hours = await getSettingNumber("newsletter.confirmValidHours").catch(() => null);
  const manage = hours ? await confirmSubscription(token, hours * 3_600_000) : null;
  if (!manage) return { error: "link-invalid" };
  redirect(`/${locale}/newsletter/confirm?confirmed=${encodeURIComponent(manage)}`);
}
